// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1wwuh","file":"styles_file__3ZgnK"};